<template>
  <div>
    <hi-row flex separator class="action-block" @click.native="dbMaintenance">
      <v-col cols="5">
        <div>DataBase Maintenance</div>
      </v-col>
      <v-col cols="7">
        <div class="ui-text">Auto Update Source</div>
        <div class="ui-text">Find duplicated emails</div>
      </v-col>
    </hi-row>
    <hi-row
      flex
      separator
      class="action-block"
      @click.native="mobileNumbersChecker"
    >
      <v-col cols="5">
        <div>Check Mobile Numbers</div>
      </v-col>
      <v-col cols="7">
        <div class="ui-text">Auto Fix Mobile Numbers...</div>
      </v-col>
    </hi-row>
  </div>
</template>

<script>
import HiRow from "@/components/scaffold/HiRow";
// import hive from "@/hive";
export default {
  name: "Maintenance",
  components: { HiRow },
  methods: {
    async dbMaintenance() {
      // console.log("click");
      // await hive.confirm(
      //   "Database maintenance may take a long time. Are you willing to continue?"
      // );
      this.$emit("dbMaintenance");
    },
    mobileNumbersChecker() {
      this.$emit("mobileNumbersChecker");
    }
  }
};
</script>

<style scoped>
.action-block {
  transition: background-color 0.5s;
  cursor: pointer;
}
.action-block:hover {
  background-color: rgba(255, 255, 255, 0.5);
}
</style>
